import { Descriptions, Empty, Row } from 'antd';
import axios from 'axios';
import { FileText, LayoutList, Users } from 'lucide-react';
import { useEffect, useState } from 'react';

import { Additional, Delivery, Execution, Procurement, Warehousing } from './contract-services';
import FieldInput, { descriptionProps } from './FieldInput';
import './profilepage.less';

/** Ачаалж байх үед харуулах хий мөрийн тоо */
const SKELETON_ROWS = 4;

/** Үйлчилгээний төрлийн товч нэр — хураангуйд жагсаахад ашиглана */
const SERVICE_LABELS = {
  delivery: 'Хүргэлт',
  execution: 'Агуулах дээрх захиалга',
  executionOnDemand: 'Татан авалттай захиалга',
  warehousing: 'Хадгалалт',
  procurement: 'Татан авалт',
  additional: 'Нэмэлт үйлчилгээ',
};

const ContractTab = () => {
  const [contractInfo, setContractInfo] = useState(null);
  const [contractTypes, setContractTypes] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await axios.get('/api/v1/me/mycontract?raw=true');
        setContractInfo(data?.result ?? null);
        setContractTypes(data?.contracts ?? {});
      } catch (e) {
        console.error('Fetch My Contract: ', e);
      }
      setLoading(false);
    };
    void fetchData();
  }, []);

  /** Гэрээний төрөл нь "WO" мэт үсгүүдээр ирдэг тул тайлж уншуулна */
  const typeNames = (contractInfo?.contractType ?? '')
    .split('')
    .map((char) => contractTypes[char])
    .filter(Boolean);

  const services = contractInfo?.services ?? [];
  const contractType = contractInfo?.contractType;

  /** Гэрээнд тохирсон үйлчилгээний төрлүүд — доорх хэсгүүдтэй ижил дараалалтай */
  const serviceNames = Object.keys(SERVICE_LABELS)
    .filter((type) => services.some((service) => service.serviceType === type))
    .map((type) => SERVICE_LABELS[type]);

  /** Аль сувгаар үнэ тохирсон нь — тарифын мөрүүдийн тэмдэглэгээнээс */
  const channels = [
    services.some((service) => service.isB2B) && 'B2B',
    services.some((service) => service.isB2C) && 'B2C',
  ].filter(Boolean);

  const renderBody = () => {
    if (loading) {
      return (
        <div className="contract__skeleton">
          {Array.from({ length: SKELETON_ROWS }).map((_, index) => (
            <span className="contract__skeleton-row" key={index} />
          ))}
        </div>
      );
    }

    if (!services.length) {
      return (
        <div className="contract__empty">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Гэрээний нөхцөл бүртгэгдээгүй байна."
          />
        </div>
      );
    }

    /*
     * Хэсэг бүр өөрөө `Col` учраас өргөн дэлгэц дээр хоёр хоёроороо зэрэгцэнэ.
     * Үйлчилгээ нь гэрээнд байхгүй хэсэг null буцаадаг тул хоосон багана үлдэхгүй.
     */
    return (
      <Row gutter={32} className="contract__sections">
        <Delivery services={services} />
        {['WO', 'W'].includes(contractType) && <Execution services={services} type="W" />}
        {['WO', 'O'].includes(contractType) && <Execution services={services} type="O" />}
        <Warehousing services={services} />
        <Procurement services={services} />
        <Additional services={services} />
      </Row>
    );
  };

  return (
    <div className="pp_table_wrapper">
      <div className="contract__head">
        <h3 className="contract__title">Гэрээний нөхцөл</h3>
        <p className="contract__hint">Гэрээгээр тохирсон үйлчилгээ, төлбөрийн нөхцөл.</p>
      </div>

      {!loading && (
        <div className="contract__summary">
          <Descriptions
            {...descriptionProps}
            items={[
              {
                key: 'contractType',
                label: 'Гэрээний төрөл',
                span: 2,
                children: <FieldInput icon={FileText} value={typeNames.join(', ')} wide />,
              },
              {
                key: 'channels',
                label: 'Үнэ тохирсон суваг',
                children: <FieldInput icon={Users} value={channels.join(', ')} />,
              },
              {
                key: 'services',
                label: 'Гэрээнд багтсан үйлчилгээ',
                span: 3,
                children: <FieldInput icon={LayoutList} value={serviceNames.join(', ')} wide />,
              },
            ]}
          />
        </div>
      )}

      {renderBody()}
    </div>
  );
};

export default ContractTab;
